<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2UYHtE/tc-custom/9781452110301.jpg?1737754905732" alt="This image is the cover for the book Girl in the Kitchen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Girl in the Kitchen
      </h1>
      <p class="bookDescription body article font2">
        <b>“Exudes a down-to-earth vibe. Packed with creative recipes constructed from fresh seasonal produce . . . accessible and inspiring at the same time.” —<i>HuffPost</i></b><br/><br/>Stephanie Izard knows how to inspire, captivate, and cook up a storm. Fan favorite and the first and only woman to win on TV’s <i>Top Chef</i>, she’s also the chef and owner of the acclaimed Girl &amp; the Goat restaurant in Chicago. <i>Girl in the Kitchen</i> collects more than one hundred of Izard’s best recipes, from innovative appetizers like Asian-Spiced English Peas to luscious desserts like Quince and Fig Cobbler with Vanilla Mascarpone. Beautifully photographed and bursting with flavor, personality, and insights into the top chef’s process—including where she finds her cooking muses, how she shops for food, and which beers and wines she chooses to accompany her meals—this book represents the culmination of a craft and provides inspiration that reaches far beyond the kitchen walls.<br/><br/><b>“A cookbook that should make anyone comfortable in the kitchen. The photos by Dan Goldberg are lush, and tips throughout cover techniques, ingredients, and wine or beer pairings for each dish. Izard wants her readers to have fun and even invites them to change up the recipes—just the way a professional chef does.” —<i>Chicago</i> magazine</b><br/><br/><b>“Stephanie’s book is not only one of the most visibly appealing and beautiful cookbooks I’ve seen in a very long time, it’s also filled with awesome creative recipes that are sensible (like her). Stephanie is an amazing chef, an immense talent and a wonderful woman.” —Michelle Bernstein, James Beard Award–winning chef</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Izard, Heather Shouse, Dan Goldberg
      </h2>
      
      <p class="authorDescription body article">Stephanie Izard was named Top Chef in season four of the award-winning Bravo series, and is now chef/owner of Girl & the Goat in Chicago.Heather Shouse is a Chicago-based reporter for Food & Wine and the Eat & Drink editor of Time Out Chicago.Dan Goldberg is a Chicago-based food and lifestyle photographer. His work for Chronicle Books includes Latin Grill.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c4cfe8f0